import { Blockchain } from "@rarible/api-client"
import { hedera } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const hederaEvmConfig: StaticEthereumBlockchainConfig = {
  name: "Hedera",
  icon: "/images/blockchains/hederaevm.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://hederaevm-api.rarible.org",
  chainId: hedera.id,
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  blockchain: Blockchain.HEDERAEVM,
  chainName: hedera.name,
  exchange: {
    v2: "0x30fc6eed1d302F5f5C4a8aa58047d1a730b3Cc91",
    wrapper: "0xBFb17500344bA3475d46091F5c8f1e33B31ed909",
  },
  blockExplorers: [
    {
      url: "https://hashscan.io/mainnet",
      icon: "/images/scanner.svg",
      adress: "https://hashscan.io/mainnet/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "hederaevm-node",
  transferProxies: {
    nft: "0x57559104c0e4fbc578fF4251b63eA0903d7CAe32",
    erc721Lazy: "0x13b05523634ABb96E6017Da71b7698CAecDf50b2",
    erc20: "0x4217a346C8b48731641327b65bb6F6d3243d64e2",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("HEDERAEVM:0x0000000000000000000000000000000000000000"),
    symbol: "HBAR",
    name: "HBAR",
    decimals: 8,
  },
  wrappedCurrency: {
    id: toCurrencyId("HEDERAEVM:0xb1f616b8134f602c3bb465fb5b5e6565ccad37ed"),
    symbol: "WHBAR",
    name: "Wrapped HBAR",
    decimals: 8,
  },
  addFundsLink: "https://app.hashport.network/",
  hasStabilityProtocol: false,
  viem: hedera,
}

export const getHederaEvmConfig = (): StaticEthereumBlockchainConfig =>
  hederaEvmConfig
